import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";

const ValuesRequestView = ({...props}) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Prestatario \ Solicitud de Valores"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button label="Buscar" style={{'float': 'right'}}
                                onClick={props.getOrderBorrowerList}/>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Captura Postura"
                                    className="p-button-secondary"
                                    onClick={props.setOrderBorrower}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="content-section implementation">
                            <DataTable value={props.orderBorrowerList}
                                       selectionMode="single"
                                       responsive={true}
                                       onSelectionChange={props.handleSelectOrder}
                                       resizableColumns={true}
                                       columnResizeMode={"fit"}>
                                <Column field="folio" header="Folio"
                                        style={{textAlign: 'left'}}
                                        sortable={true}/>
                                <Column field="tipo" header="Tipo"
                                        style={{textAlign: 'left'}}
                                        sortable={true}/>
                                <Column field="emisora" header="Emisora"
                                        style={{textAlign: 'left'}}
                                        sortable={true}/>
                                <Column field="cantidad" header="Títulos"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate}
                                        sortable={true}/>
                                <Column field="plazo" header="Plazo"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate}
                                        sortable={true}/>
                                <Column field="tasa" header="Tasa"
                                        style={{textAlign: 'right'}}
                                        body={rateMultipliedByOneHundredDataTableTemplate}
                                        sortable={true}/>
                                <Column field="sobreTasa" header="Sobretasa"
                                        style={{textAlign: 'right'}}
                                        body={rateMultipliedByOneHundredDataTableTemplate}
                                        sortable={true}/>
                                <Column field="precio" header="Precio"
                                        style={{textAlign: 'right'}}
                                        body={priceDataTableTemplate}
                                        sortable={true}/>
                                <Column header="Acciones"
                                        body={props.editOrderActionTemplate}
                                        style={{textAlign: 'center', width: '8em'}}/>
                            </DataTable>
                            {props.confirmationMsg}
                        </div>
                    </Grid>
                </Grid>
            </Paper>

        </React.Fragment>
    )
};

export default (ValuesRequestView);
